import React from 'react'

// Components
import Highlighted from './Highlighted'
import Overview from './Overview'

export interface CasesProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Cases
  location?: any
}

interface PostProps {
  [key: string]: any
}

const CasesShell: React.FC<CasesProps> = ({ fields, location = {} }) => {
  const types: PostProps = {
    overview: Overview,
    highlighted: Highlighted,
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default CasesShell
